import { Select as AntSelect } from "antd";
import type { SelectProps } from "antd/es/select";
import { cn } from "@/shared/lib/utils";

export function Select({ className, ...props }: SelectProps) {
  const isBorderless = props.variant === "borderless";
  return (
    <AntSelect
      className={cn(
        "!w-full [&_.ant-select-selector]:!text-sm [&_.ant-select-selector]:!text-[#3A3D42] [&.ant-select-borderless_.ant-select-selector]:!border-0 [&.ant-select-borderless_.ant-select-selector]:!shadow-none",
        isBorderless && "msq-select-borderless",
        className,
      )}
      {...props}
    />
  );
}
